var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"login-page"},[_c('LoginForm',{attrs:{"mode":"page","event-id":_vm.$route.query.event || null,"redirect":_vm.$route.query.redirect || null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }